export default function processPostsListAJAX(url, formId) {
    // Store element that will have updated content
    formId = formId.substring(8);
    let $postsListContainer = $('#filter-container-' + formId);
    let postsListContainer = document.getElementById(
        'filter-container-' + formId
    );

    let $postsListLoader = $('.visc-posts-list__loader');

    // Get new results using AJAX
    $.ajax({
        url,
        dataType: 'html',
        beforeSend: function () {
            // Show the user something is happening
            $postsListLoader.addClass('visc-posts-list__loader--active');
        },
        success: function (data) {
            // Get all the new content inside of the container
            let updatedContent = $(data).find(
                '#filter-container-' + formId + ' > *'
            );

            // Display the new data in the container
            $postsListContainer.empty();
            $postsListContainer.append(updatedContent);

            // Scroll to the top of the list container
            postsListContainer.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
                inline: 'nearest',
            });
            // Show the user the request is comlete
            $postsListLoader.removeClass('visc-posts-list__loader--active');
            // Need to re-run this after each complete AJAX too
            // postsListPaginationAJAXHandler();
            history.pushState('', document.title, url);
            // Create custom JS event to listen to for custom JS after AJAX is complete
            $(document).trigger('visceralPosts:ajaxSuccess');
        },
    });
}



// WEBPACK FOOTER //
// ./scripts/util/processPostsListAJAX.js